module.exports = __webpack_public_path__ + "static/media/moving-with-van_2x.9e6527c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/moving-with-van_2x.png
// module id = 1182
// module chunks = 27